export const Banks = [
    { number: '321', name: 'Sociedade de Crédito Direto S.A.' },
    { number: '121', name: 'Banco Agibank S.A.' },
    { number: '330', name: 'Banco Bari de Investimentos e Financiamentos S.A.' },
    { number: '318', name: 'Banco BMG S.A.' },
    { number: '237', name: 'Banco Bradesco S.A.' },
    { number: '208', name: 'Banco BTG Pactual S.A.' },
    { number: '336', name: 'Banco C6 Consignado S.A.' },
    { number: '756', name: 'Banco Cooperativo do Brasil S.A. – Bancoob' },
    { number: '748', name: 'Banco Cooperativo Sicredi S.A.' },
    { number: '707', name: 'Banco Daycoval S.A.' },
    { number: '335', name: 'Banco Digio S.A.' },
    { number: '001', name: 'Banco do Brasil S.A.' },
    { number: '041', name: 'Banco do Estado do Rio Grande do Sul S.A. (Banrisul)' },
    { number: '012', name: 'Banco Inbursa S.A.' },
    { number: '077', name: 'Banco Inter S.A.' },
    { number: '340', name: 'Banco Master S.A.' },
    { number: '389', name: 'Banco Mercantil do Brasil S.A.' },
    { number: '623', name: 'Banco PAN S.A.' },
    { number: '611', name: 'Banco Paulista S.A.' },
    { number: '643', name: 'Banco Pine S.A.' },
    { number: '741', name: 'Banco Ribeirão Preto S.A.' },
    { number: '422', name: 'Banco Safra S.A.' },
    { number: '033', name: 'Banco Santander (Brasil) S.A.' },
    { number: '655', name: 'Banco Votorantim S.A. (BV)' },
    { number: '610', name: 'Banco VR S.A.' },
    { number: '021', name: 'Banestes S.A. – Banco do Estado do Espírito Santo' },
    { number: '104', name: 'Caixa Econômica Federal' },
    { number: '149', name: 'Facta Financeira S.A. – Crédito, Financiamento e Investimento' },
    { number: '341', name: 'Itaú Unibanco S.A.' },
    { number: '197', name: 'Stone Pagamentos S.A.' },
    { number: '260', name: 'Nu Financeira S.A. (Nubank)' },
    { number: '290', name: 'Pagseguro Internet S.A.' },
    { number: '380', name: 'PicPay Bank – Banco Múltiplo S.A.' },
    { number: '326', name: 'Parati Crédito, Financiamento e Investimentos S.A.' },
    { number: '329', name: 'QI Sociedade de Crédito Direto S.A.' },
    { number: '373', name: 'Up.P Sociedade de Empréstimo entre Pessoas S.A.' },
    { number: '284', name: 'Realize Crédito, Financiamento e Investimento S.A.' },
    { number: '274', name: 'Money Plus Sociedade de Crédito ao Microempreendedor S.A.' },
    { number: '093', name: 'Pólocred Sociedade de Crédito Direto S.A.' },
    { number: '140', name: 'Easynvest – Corretora de Valores S.A. (Itaú Corretora)' },
    { number: '741', name: 'RPW S.A. – Crédito, Financiamento e Investimento' },
    { number: '719', name: 'Banif Financeira S.A.' },
    { number: '733', name: 'Socinal S.A. – Crédito, Financiamento e Investimento' },
    { number: '737', name: 'Will Financeira S.A. – Crédito, Financiamento e Investimento' },
    { number: '747', name: 'Zema Crédito, Financiamento e Investimentos S.A.' },
    { number: '332', name: 'Acesso Soluções de Pagamento S.A.' },
    { number: '403', name: 'Cora Sociedade de Crédito Direto S.A.' },
    { number: '408', name: 'Bônuscred Sociedade de Crédito Direto S.A.' },
    { number: '404', name: 'SumUp Sociedade de Crédito Direto S.A.' },
    { number: '234', name: 'BANCO LAVRA S.A.' }
  ];
  